// src/components/Layout.tsx
import { Link, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import useAuth from "../context/AuthContext";
import Sidebar from "./Sidebar";

export default function Layout() {
  const { user, isAuthenticated, logout } = useAuth();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 1024);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div className="flex">
      <Sidebar />

      <div
        className="w-full flex-1 transition-[margin-left] duration-300"
        style={{ marginLeft: isMobile ? 0 : 76 }}
      >
        <header
          className="flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3 md:px-5"
          style={{ background: "var(--header-bg)", borderColor: "var(--border)" }}
        >
          <nav className="flex flex-wrap items-center gap-3">
            <Link to="/clients">Clients</Link>
            <Link to="/engagements">Engagements</Link>
          </nav>

          <div className="flex items-center gap-3">
            {isAuthenticated ? (
              <>
                <span className="font-bold">
                  {user?.name || user?.email || "User"}
                </span>
                <button
                  onClick={() => logout()}
                  className="cursor-pointer px-3 py-1.5"
                >
                  Logout
                </button>
              </>
            ) : (
              <Link to="/login">Login</Link>
            )}
          </div>
        </header>

        <main className="p-4 md:p-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
